"use strict";

(function( namespace ) {
	var config = {};

	/**
	* Load global variables. Fallback to default values if not found.
	*/
	namespace.loadEnvVars = function() {
		config.timeout = window.LUMIERE_TIMEOUT || 10000;
		config.playerClass = window.LUMIERE_PLAYER_CLASS || "hearstLumierePlayer";
		config.nitehawkUrl = window.LUMIERE_NITEHAWK_URL;
		config.imaSdkUrl = window.LUMIERE_IMA_SDK_URL || "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
		config.gaUrl = window.LUMIERE_GA_URL || "https://www.google-analytics.com/analytics.js";
		config.youboraAccCode = window.LUMIERE_YOUBORA_ACC_CODE || "hearst";
		config.logLevel = window.LUMIERE_LOG_LEVEL || "all";
	};

	/**
	* Return LUMIERE_TIMEOUT.
	*/
	namespace.getTimeout = function() {
		return config.timeout;
	};

	/**
	* Return LUMIERE_PLAYER_CLASS.
	*/
	namespace.getPlayerClass = function() {
		return config.playerClass;
	};

	/**
	* Return LUMIERE_NITEHAWK_URL.
	*/
	namespace.getNitehawkUrl = function() {
		return config.nitehawkUrl;
	};

	/**
	* Return LUMIERE_IMA_SDK_URL.
	*/
	namespace.getImaSdkUrl = function() {
		return config.imaSdkUrl;
	};

	/**
	* Return LUMIERE_YOUBORA_ACC_CODE.
	*/
	namespace.getYouboraAccCode = function() {
		return config.youboraAccCode;
	};

	/**
	* Return LUMIERE_GA_URL.
	*/
	namespace.getGaUrl = function() {
		return config.gaUrl;
	};

	/**
	* Return LUMIERE_LOG_LEVEL.
	*/
	namespace.getLogLevel = function() {
		return config.logLevel;
	};
})( window.hearstLumierePlayer = window.hearstLumierePlayer || /* istanbul ignore next */ {} );



//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 65
// module chunks = 0